import React, { useState } from "react";
import { Search } from "lucide-react";
import { font } from "../Simulation/constants";

function SearchBar({ placeholder, value, onChange }) {
  const [focused, setFocused] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        background: "#ffffff",
        border: "none",
        borderRadius: 8,
        padding: "10px 14px",
        transition: "box-shadow 0.2s",
        boxShadow: focused
          ? "0 1px 3px rgba(0,0,0,0.06), 0 0 0 2px rgba(255,75,79,0.2)"
          : "0 1px 3px rgba(0,0,0,0.06)",
      }}
    >
      <span
        style={{
          marginRight: 10,
          opacity: 0.4,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Search size={16} />
      </span>
      <input
        placeholder={placeholder || "Search..."}
        value={value || ""}
        onChange={(e) => onChange?.(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          background: "transparent",
          border: "none",
          outline: "none",
          color: "#363636",
          fontSize: 14,
          width: "100%",
          fontFamily: font,
        }}
      />
    </div>
  );
}

export default SearchBar;
